<template>
  <div class="userLog-main-content">
    <div class="search">
      <el-form class="searchForm" :model="searchForm">
        <el-form-item>
          <el-input size="small" :min-width="100" v-model="searchForm.name" placeholder="输入账号、操作内容...."></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">新增</el-button>
        </el-form-item>
      </el-form>

    </div>
    <div class="table">
      <el-table stripe size="medium" :data="list" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" prop="name" label="产品名称" min-width="250"></el-table-column>
        <el-table-column align="center" prop="image" label="封面图片" min-width="150">
          <template v-slot:default="scope">
            <el-image :src="scope.row.image" />
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" min-width="80" align="center">
          <template slot-scope="scope">
            <el-input type="text" v-model.lazy="scope.row.sort" @change="editSort(scope.row)" class="tableSort">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="flag" label="显示状态" min-width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.flag == 1 ? nshow : fshow" active-color="#13ce66" inactive-color="#ff4949"
              @change="editFlag(scope.row)"></el-switch>
          </template>
        </el-table-column>


        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="success" plain @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- edit start -->
    <el-dialog style="max-height:60vh;" :title="editTitle" :visible.sync="editFormVisible" width="50%"
      @click="closeDialog">
      <el-form label-width="140px" :model="formData" :rules="rules" ref="formData">

        <el-form-item style="margin-bottom:6px;" label="产品名称" prop="name">
          <el-input size="small" style="width:80%" v-model="formData.name" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="上传图片">
          <el-upload class="avatar-uploader" action="/apiNQ/api/common/upload" :show-file-list="false"
            :on-success="handleTreeImgSuccess" :before-upload="beforeTreeImgUpload" name="file"
            :on-progress="onTreeImgProgress">
            <img v-if="formData.image" :src="formData.image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="图片路径">
          <el-input size="small" style="width:80%" v-model="formData.image" class="form-input"></el-input>
        </el-form-item>


        <el-form-item>
          <el-button size="small" type="primary" @click="submitForm('formData')">提交保存</el-button>
          <el-button size="small" @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- edit end -->
  </div>
</template>

<script>
import { gt0 } from '../utils/util';
import { user_refresh_token, itemName_list, itemName_update_sort, itemName_editFlag, itemName_update, itemName_add } from "../api/api";

import './../assets/css/userLog.css';

export default {
  data() {
    return {
      timer: null, // 定时器
      // 页面控制元素
      loading: false, //是否显示加载
      editTitle: '', //编辑页面标题
      editType: 1, // 新增/修改
      editFormVisible: false, // 编辑页面显隐
      nshow: true, //switch开启
      fshow: false, //switch关闭
      // 搜索表单
      searchForm: {
        name: ''
      },
      formData: {
        id: '',
        name: '',
        image: ''
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },

      // 列表
      list: []
    };
  },

  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end

    this.getData();
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken()
        }, 10 * 60 * 1000)
      }
    },
    async refreshToken() {
      let param = { "page": "userlog", "token": window.localStorage.getItem("user") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("user", data.data);
    },

    // ----------------------search start---------------------
    search() {
      this.getData();
    },
    async getData() {
      let param = { name: this.searchForm.name }
      const data = await itemName_list(param);
      this.list = data.data;
    },

    // ----------------------search end---------------------

    // 修改排序
    async editSort(data) {
      if (!gt0(data.sort)) {
        this.$message({
          message: "请输入大于0的数字！",
          type: "warning"
        });
        return;
      }
      const params = { id: data.id, sort: data.sort };
      await itemName_update_sort(params);
      this.getData();

      this.$message({
        message: "操作成功!",
        type: "success"
      });
    },
    // 修改显示状态
    async editFlag(data) {
      data.flag = data.flag == 1 ? 0 : 1;
      const param = { id: data.id, flag: data.flag };
      await itemName_editFlag(param);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
    },

    // ----------------------add start---------------------
    handleEdit: function (row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.editTitle = "修改产品名称";
        this.editType = 2;

        this.formData.id = row.id;
        this.formData.name = row.name;
        this.formData.image = row.image;
      } else {
        this.editTitle = "新增产品名称";
        this.editType = 1;

        this.formData.id = "";
        this.formData.name = "";
        this.formData.image = "";
      }
    },

    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.editType == 1) {
            this.add(this.formData);
          }
          else if (this.editType == 2) {
            this.update(this.formData);
          }
          this.editFormVisible = false;
          this.loading = false;
        } else {
          return false;
        }
      });
    },

    //新增 修改
    async add() {
      await itemName_add(this.formData);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearFormData();
      this.getData();
    },
    async update() {
      await itemName_update(this.formData);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearFormData();
      this.getData();
    },

    clearFormData() {
      this.formData.id = "";
      this.formData.name = "";
      this.formData.image = "";
    },
    closeDialog() {
      this.clearFormData();
      this.editFormVisible = false;
    },
    closeDialogUserLog() {
      this.clearFormData();
      this.editFormVisibleUserLog = false;
    },


    // ----------------------add end-----------------------

    //====================上传封面照片   start  ==============
    // 上传图片 start
    handleTreeImgSuccess(res, file) {
      URL.createObjectURL(file.raw);
      this.formData.image = res.data
    },
    onTreeImgProgress(proxyReq, req, res) {
      console.log("原路径：" + req.originalUrl, "代理路径：" + req.path)
    },
    beforeTreeImgUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      } else {
        return true;
      }
    },

    // 上传图片 end
    //====================上传封面照片   end  ==============

  }
};
</script>
<style scoped>
.el-image {
  width: 80px;
  height: 80px;
}
</style>





// WEBPACK FOOTER //
// src/views/ItemName.vue